document.addEventListener('DOMContentLoaded', function () {
    // Quantity stepper
    document.querySelectorAll('.pm-qty').forEach(function (qty) {
        var input = qty.querySelector('.qty-input');
        qty.querySelector('.minus').addEventListener('click', function () {
            var v = parseInt(input.value, 10);
            if (v > 1) input.value = v - 1;
        });
        qty.querySelector('.plus').addEventListener('click', function () {
            input.value = parseInt(input.value, 10) + 1;
        });
    });

    // Web Share / clipboard fallback
    document.querySelectorAll('.pm-share-btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            var url = btn.dataset.productUrl || window.location.href;
            if (navigator.share) {
                navigator.share({ url: url });
            } else {
                navigator.clipboard.writeText(url).then(function () {
                    btn.textContent = 'Copied!';
                    setTimeout(function () {
                        btn.innerHTML = '<svg viewBox="0 0 13 17" fill="none" aria-hidden="true"><path d="M6.03247 0L3.01624 3.01624H5.27841V9.80276H6.78653V3.01624H9.04871M10.5568 16.5893H1.50812C0.671112 16.5893 0 15.9106 0 15.0812V6.03247C0 5.63249 0.15889 5.2489 0.441717 4.96607C0.724544 4.68324 1.10814 4.52435 1.50812 4.52435H3.77029V6.03247H1.50812V15.0812H10.5568V6.03247H8.29465V4.52435H10.5568C10.9568 4.52435 11.3404 4.68324 11.6232 4.96607C11.9061 5.2489 12.0649 5.63249 12.0649 6.03247V15.0812C12.0649 15.4812 11.9061 15.8647 11.6232 16.1476C11.3404 16.4304 10.9568 16.5893 10.5568 16.5893Z" fill="white"/></svg> Share';
                    }, 2000);
                });
            }
        });
    });

    // Swiper gallery
    if (typeof Swiper === 'undefined') return;

    var thumbSwiper = new Swiper('.swiper-thumbnail', {
        direction: window.innerWidth > 991 ? 'vertical' : 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        watchSlidesProgress: true,
        breakpoints: {
            992: {
                direction: 'vertical',
                slidesPerView: 3,
                spaceBetween: 15
            }
        }
    });

    new Swiper('.swiper-main', {
        spaceBetween: 10,
        thumbs: { swiper: thumbSwiper },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    });
});
